
  import {mapSectionComponents} from '@/helper/SectionHelper';
  import {getMetaTags} from '@/helper/Seo';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';

  export default {
    name: 'OrganizationArticlesCategory',
    components: {
      LazyHydrate,
    },
    layout: 'organization',
    async asyncData({route, error, $cachedStrapi, app, store}) {
      // Initialize variables
      const filterParams = {
        search_term: null,
        categories: [],
      };

      // Query page from Strapi; strapi-change for findOne is required!
      const pagePromise = $cachedStrapi
        .findOne('pages', 'organization-articles-category')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      // Query article-category from Strapi; strapi-change for findOne is required!
      const articleCategoryPromise = $cachedStrapi
        .findOne('article-categories', route.params.category)
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      const [page, articleCategory] = await Promise.all([
        pagePromise,
        articleCategoryPromise,
      ]);

      if (
        !scopeHelper(page, process.env.SCOPE_ORGANIZATION) ||
        !scopeHelper(articleCategory, process.env.SCOPE_ORGANIZATION)
      ) {
        error({statusCode: 404, message: 'Article not found'});
        return;
      }

      filterParams.categories = [articleCategory.slug];

      const sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionArticleListingWithFilter':
              section.filterParams = filterParams;
              section.content_scope = process.env.SCOPE_ORGANIZATION;
              break;

            case 'SectionBreadcrumbs':
              section.breadcrumbs = [
                {
                  text: app.i18n.t('page.index'),
                  disabled: false,
                  to: app.localePath({
                    name: 'organization',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: app.i18n.t('page.articles'),
                  disabled: false,
                  to: app.localePath(
                    store.getters['breadcrumbs/hasArticleListingRoute']
                      ? store.state.breadcrumbs.lastArticleListingRoute.split(
                          '#'
                        )[0]
                      : {
                          name: 'organization-articles',
                        }
                  ),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: articleCategory.title,
                  disabled: true,
                  to: app.localePath({
                    name: 'organization-articles-category',
                    params: {
                      category: articleCategory.slug,
                    },
                  }),
                  nuxt: true,
                  exact: true,
                },
              ];
              break;

            case 'SectionSeoContent':
              if (
                articleCategory.seo_content_config &&
                articleCategory.seo_content_config.seo_contents &&
                articleCategory.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  articleCategory.seo_content_config.seo_contents[0].id
                );
              } else if (
                section.seo_content_config &&
                section.seo_content_config.seo_contents &&
                section.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  section.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );

      const metaData =
        articleCategory && articleCategory.meta
          ? articleCategory.meta
          : page && page.meta
          ? page.meta
          : {};

      return {
        metaData,
        articleCategory,
        filterParams,
        sections,
      };
    },
    data() {
      return {
        metaData: {},
        articleCategory: {},
        sections: [],

        filterParams: {
          search_term: null,
          categories: [],
        },
      };
    },
    head() {
      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
      };
    },
    methods: {
      setFilterParams(params) {
        this.filterParams = params;
      },
      resetFilterParams() {
        this.filterParams = {};
        this.page = 1;
      },
    },
  };
